module.exports = __webpack_public_path__ + "static/media/2、张家口经开区“未来之城”投融资规划-min.4bbcbd7e.jpg";